export const appConfig = {
  mtvSetup: {
    id: "mtv-container12",
    path: "https://d3klq1qh6r64da.cloudfront.net/api_uploads/mtv-master/jme/",
    mode: "jme", //NOTE: new JMT or JME mode
    //play_rid:4589,
    //play_manage_room_id: 0,
    //play_manage_session_id: 909,
    //play_sid: 52357,
    //base_api: "",
    //base_api: "staging-api.virtual-meeting.net",
    //include_sponsor:0,
    base_api: "api.virtual-meeting.net",
    event_id: 460, //15
    playIdConfig:true,
    
  },
  partnerDomain:"fake.m-events.com"
};
